__turbopack_context__.v({
  "actions": "CreatePlaylistModal-module__vORWfq__actions",
  "cancel": "CreatePlaylistModal-module__vORWfq__cancel",
  "confirm": "CreatePlaylistModal-module__vORWfq__confirm",
  "heading": "CreatePlaylistModal-module__vORWfq__heading",
  "input": "CreatePlaylistModal-module__vORWfq__input",
  "modal": "CreatePlaylistModal-module__vORWfq__modal",
  "overlay": "CreatePlaylistModal-module__vORWfq__overlay",
});
